export default __webpack_public_path__ + "static/media/36I-102813_-16001_0.fa82a08a.jpg";